import { Table, Switch, Tag, Space, Button, Form, Input, Row, Col, Typography } from 'antd';
// import { data } from 'data/pipelinepartnumber';
import { useTheme } from 'contexts/theme';
import DealFilter from 'components/form/dealFilter';
import { PRIMARY, GREEN, ORANGE, RED } from 'utils/colors';
import { FileSearchOutlined } from '@ant-design/icons';
import Dropdown from 'components/Dropdown';
import { EditOutlined, SaveOutlined, UndoOutlined } from '@ant-design/icons';
import { useState } from 'react';

export default function PipeLinePartNumberMapperTable({
    data,
    totalCount,
    handlePagination,
    loading,
    onFilter,
    repField,
    setZipMatch,
    zipMatch,
    mfgPartNo,
    distPartNumbers,
    onSave,
}) {
    const { Title } = Typography;
    const { dark } = useTheme();
    const [editingKey, setEditingKey] = useState('');
    const [save] = onSave();
    const partNumberLimiterLiteral = 'Part Number Limiter : ';

    const isEditing = (record: any) => {
        return record.id === editingKey;
    };

    const [form] = Form.useForm();

    const editOperation = (record: any & { key: React.Key }) => {
        form.setFieldsValue({ ...record });
        setZipMatch('');
        setEditingKey(record.id);
    };

    async function handleSave(data: any) {
        const record = { ...data, ...form.getFieldsValue(true) };
        const payload = {
            dealId: record.id,
            dealPartNumbers: [
                // ...record.dealPartNumbers,
                ...(record.mfgPartNo && typeof record.mfgPartNo === 'object'
                    ? record.mfgPartNo.map((item) => ({
                        id: null,
                        partNumber: item,
                        partNumberType: 'M',
                    }))
                    : []),
                ...(record.distrPartNo && typeof record.distrPartNo === 'object'
                    ? record.distrPartNo.map((item) => ({
                        id: null,
                        partNumber: item,
                        partNumberType: 'D',
                    }))
                    : []),
            ],
            remarks: record.remarks,
            status: 'Good',
        };
        console.log(payload);
        save(payload);
        // const operation = edit || save;
        // await operation({ ...record, ...form.getFieldsValue(true) });
        setEditingKey('');
    }

    function handleChange(name: string, value: any) {
        form.setFieldsValue({ [name]: value });
    }

    function getColor(text: any) {
        if (text === 'Good') return GREEN;
        if (text === 'Warn') return ORANGE;
        if (text === 'Error') return RED;
        return PRIMARY;
    }

    const EditField: React.FC<any> = ({
        editing,
        dataIndex,
        title,
        record,
        index,
        children,
        dataSource,
        label,
        valueKey,
        allOptionName,
        isSwitch,
        ...restProps
    }) => {
        const renderField = () => {
            // const field = formFields.find(
            //   (field: { name: string }) => field.name === dataIndex
            // );
            // if (!(field || label || dataSource || isSwitch)) return null;
            return (
                <Form.Item
                    key={dataIndex}
                    name={dataIndex}
                    style={{ margin: 0 }}
                    rules={[
                        {
                            required: true,
                            message: `Enter ${title}`,
                        },
                    ]}
                >
                    {isSwitch ? (
                        <Switch
                            defaultChecked={false}
                            checked={!!zipMatch}
                            onChange={(checked) =>
                                setZipMatch(checked ? record.companyZip : '')
                            }
                        />
                    ) : dataSource ? (
                        <Dropdown
                            onChange={(value: any) =>
                                handleChange(dataIndex, value)
                            }
                            mode="multiple"
                            dataSource={[...Array.from(new Set(dataSource))]}
                            // defaultValue={record && record[dataIndex]}
                            // placeholder={label || (field && field.label)}
                            valueKey=""
                            // allOptionName={allOptionName || (field && field.allOptionName)}
                            style={{ width: 180 }}
                        />
                    ) : (
                        <Input placeholder={label} type="text" />
                    )}
                </Form.Item>
            );
        };

        return <td {...restProps}>{editing ? renderField() : children}</td>;
    };

    const columns = [
        {
            title: 'Deal Name',
            dataIndex: 'dealName',
            key: 'dealName',
            render: (text: any) => <strong>{text}</strong>,
        },
        {
            title: 'Deal Id',
            dataIndex: 'dealId',
            key: 'dealId',
            render: (text: any) => <strong>{text}</strong>,
        },
        {
            title: 'Deal Amount',
            dataIndex: 'dealValue',
            key: 'dealValue',
            render: (text) => (
                <Space>
                    <span>$</span>
                    <span>{text}</span>
                </Space>
            ),
        },
        {
            title: 'Zip',
            dataIndex: 'companyZip',
            key: 'companyZip',
        },
        {
            title: 'Representative',
            dataIndex: 'dealOwner',
            key: 'dealOwner',
        },
        {
            title: 'Deal Part No',
            dataIndex: 'productPartNumbers',
            key: 'productPartNumbers',
            render: (text: any) => <strong>{text}</strong>,
        },
        {
            title: 'match mfgpartnumber',
            dataIndex: 'mfgPartNo',
            key: 'mfgPartNo',
            render: (text: any) => text.toString(),
            dataSource: mfgPartNo,
            editable: true,
        },
        {
            title: 'match distpartnumber',
            dataIndex: 'distrPartNo',
            key: 'distrPartNo',
            render: (text: any) => text.toString(),
            dataSource: distPartNumbers,
            editable: true,
        },
        {
            title: 'Remarks',
            dataIndex: 'remarks',
            key: 'remarks',
            render: (text: any) => <strong>{text}</strong>,
            editable: true,
        },
        {
            title: 'Match',
            dataIndex: 'match',
            key: 'match',
            render: (text: any) =>
                text &&
                text.map((item: any) => <Tag color={PRIMARY}>{item}</Tag>),
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (text: any) => <Tag color={getColor(text)}>{text}</Tag>,
        },
        {
            title: 'Available',
            dataIndex: 'available',
            key: 'available',
        },
        {
            title: 'Updated Date',
            dataIndex: 'dealUpdatedAt',
            key: 'dealUpdatedAt',
        },
        {
            title: 'Updated By',
            dataIndex: 'updatedBy',
            key: 'updatedBy',
        },
        {
            title: 'Sales Ref',
            key: 'salesRef',
            render: () => <FileSearchOutlined />,
        },
        {
            title: 'Zip Match',
            dataIndex: 'zipMatch',
            key: 'zipMatch',
            isSwitch: true,
            render: (text: any) => <Switch checked={false} />,
            editable: true,
        },
        {
            title: 'Edit',
            key: 'edit',
            render: (_: any, record: any) => {
                const editable = isEditing(record);
                return editable ? (
                    <Space>
                        <Button
                            icon={<SaveOutlined />}
                            className="save-icon"
                            shape="circle"
                            type="primary"
                            htmlType="submit"
                            onClick={() => handleSave(record)}
                        />
                        <Button
                            icon={<UndoOutlined />}
                            className="delete-icon"
                            shape="circle"
                            type="primary"
                            onClick={() => setEditingKey('')}
                        />
                    </Space>
                ) : (
                    <Button
                        icon={<EditOutlined />}
                        className="edit-icon"
                        shape="circle"
                        type="primary"
                        onClick={() => editOperation(record)}
                    />
                );
            },
        },
    ];

    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record: any) => ({
                record,
                ...col,
                editing: isEditing(record),
            }),
        };
    });

    return (
        <>
            <Row gutter={[10, 10]}>
                <DealFilter layout="inline" onFilter={onFilter} />
                <Col span={8}>
                    <Space size="small">
                        <Title level={5}>{partNumberLimiterLiteral}</Title>
                        {repField}
                    </Space>
                </Col>
            </Row>
            <Form form={form} component={false}>
                <Table
                    components={{
                        body: {
                            cell: EditField,
                        },
                    }}
                    style={{ marginTop: 10 }}
                    dataSource={data}
                    columns={mergedColumns}
                    className={dark ? 'table-dark' : 'table-light'}
                    loading={loading}
                    pagination={{
                        onChange: handlePagination,
                        total: totalCount,
                    }}
                />
            </Form>
        </>
    );
}
